/* ===========================================
   Atelier Bébé
   Javascript
=========================================== */


document.addEventListener("DOMContentLoaded", () => {


    const affichageTotal = document.getElementById(
        "ab-total-price"
    );


    const totalCache = document.getElementById(
        "ab-total-hidden"
    );


    const PRIX = {
        1: 25,
        2: 50,
        3: 75,
        4: 90
    };


    const PRIX_ACCOMPAGNANT = 10;



    function calculTotal() {


        let total = 0;



        document.querySelectorAll(".ab-group").forEach(groupe => {



            const formule = groupe.querySelector(
                ".ab-formule-choice:checked"
            );



            const dates = groupe.querySelectorAll(
                ".ab-date:checked"
            );



            if (!formule || dates.length === 0) {

                return;

            }



            total += PRIX[formule.value];



            groupe.querySelectorAll(
                ".ab-extra-parent:checked"
            )
            .forEach(parent => {


                const dateAssociee = parent.dataset.date;


                const dateChoisie = Array.from(
                    dates
                )
                .some(date => {

                    return date.value === dateAssociee;

                });



                if(dateChoisie){

                    total += PRIX_ACCOMPAGNANT;

                }


            });


        });



        if(affichageTotal){

            affichageTotal.textContent =
                total + " €";

        }



        if(totalCache){

            totalCache.value =
                total + " €";

        }


        return total;


    }



    function gererDates(groupe){



        const formule = groupe.querySelector(
            ".ab-formule-choice:checked"
        );



        const dates = Array.from(
            groupe.querySelectorAll(".ab-date")
        );



        if(!formule){


            dates.forEach(date => {

                date.checked = false;

                date.disabled = true;

            });


            return;

        }



        const limite = Number(
            formule.value
        );



        dates.forEach(date => {

            date.disabled = false;

        });



        if(limite === 4){


            dates.forEach(date => {

                date.checked = true;
                date.disabled = true;

            });


            return;

        }



        let selection = dates.filter(
            date => date.checked
        );



        while(selection.length > limite){


            const derniere = selection.pop();


            derniere.checked = false;


        }


    }



    function synchroniserAccompagnants(groupe){



        const dates = Array.from(
            groupe.querySelectorAll(".ab-date")
        );



        const selection = dates
            .filter(date => date.checked)
            .map(date => date.value);





        groupe.querySelectorAll(
            ".ab-extra-parent"
        )
        .forEach(parent => {



            if(selection.includes(parent.dataset.date)){


                parent.disabled = false;


            } else {


                parent.checked = false;
                parent.disabled = true;


            }



        });


    }



    document.querySelectorAll(".ab-group")
    .forEach(groupe => {



        groupe.querySelectorAll(
            ".ab-formule-choice"
        )
        .forEach(formule => {



            formule.addEventListener(
                "change",
                () => {


                    gererDates(groupe);

                    synchroniserAccompagnants(groupe);

                    calculTotal();


                }
            );


        });





        groupe.querySelectorAll(
            ".ab-date"
        )
        .forEach(date => {



            date.addEventListener(
                "change",
                () => {


                    gererDates(groupe);

                    synchroniserAccompagnants(groupe);

                    calculTotal();


                }
            );


        });





        groupe.querySelectorAll(
            ".ab-extra-parent"
        )
        .forEach(parent => {



            parent.addEventListener(
                "change",
                calculTotal
            );


        });



        gererDates(groupe);

        synchroniserAccompagnants(groupe);



    });



    calculTotal();



    /*
    ===========================================
    TRANSFORMATION AVANT ENVOI

    Les boutons radio "Formule" ont un nom
    dynamique par groupe (ex: contact[Formule
    groupe 1]), nécessaire pour que chaque
    groupe reste indépendant à l'écran.

    Juste avant l'envoi réel du formulaire,
    on les convertit en un champ cascé simple
    et statique (contact[Formule choisie]),
    puis on désactive les champs dynamiques
    d'origine pour qu'ils ne soient pas
    transmis à Shopify.
    ===========================================
    */


    const formulaire = document.querySelector(
        ".ab-groups"
    )?.closest("form");


    if (formulaire) {


        formulaire.addEventListener(
            "submit",
            (evenement) => {


                const total = calculTotal();


                if (total === 0) {

                    evenement.preventDefault();

                    alert(
                        "Merci de choisir une formule et au moins une date avant de valider votre inscription."
                    );

                    return;

                }


                document.querySelectorAll(".ab-group")
                .forEach(groupe => {


                    const formule = groupe.querySelector(
                        ".ab-formule-choice:checked"
                    );


                    if (!formule) {

                        return;

                    }


                    const nomGroupe =
                        formule.dataset.nomGroupe || "";


                   const pill =
    formule.parentElement.querySelector(
        ".ab-formule-pill"
    );


let labelTexte = formule.value;


if (pill) {


    const labelEl = pill.querySelector(
        ".ab-formule-label"
    );


    const priceEl = pill.querySelector(
        ".ab-formule-price"
    );


    const label = labelEl
        ? labelEl.textContent.trim()
        : "";


    let prix = "";


    if (priceEl) {

        priceEl.childNodes.forEach(
            (noeud) => {

                if (
                    noeud.nodeType ===
                    Node.TEXT_NODE
                ) {

                    prix += noeud.textContent;

                }

            }
        );

        prix = prix.trim();

    }


    labelTexte =
        (label + " — " + prix).trim();


}


                    const champCache =
                        document.createElement("input");


                    champCache.type = "hidden";

                    champCache.name =
                        "contact[Formule choisie]";

                    champCache.value =
                        nomGroupe + " — " + labelTexte;


                    formulaire.appendChild(champCache);


                });



                document.querySelectorAll(
                    ".ab-formule-choice"
                )
                .forEach(formule => {

                    formule.disabled = true;

                });


            }
        );


    }


});

